import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { VitalPlate, VitalPlateData } from '../plate';
import { useSessionRoomState } from '../../../../context';

export const VitalManualPeakFlow: FC = () => {
  const { t } = useTranslation(['session-room']);
  const { vitalsData } = useSessionRoomState();
  const [value, units] = useMemo(() => {
    const peakFlow = vitalsData.manualPeakFlow;
    if (peakFlow?.Value === undefined || peakFlow?.Value === null) {
      return ['-', 'L/min'];
    }

    return [Math.round(Number(peakFlow.Value)), peakFlow.Unit || 'L/min'];
  }, [vitalsData.manualPeakFlow]);

  return (
    <VitalPlate>
      <VitalPlateData
        title={t('session-room:SENSORS.PEAK_FLOW')}
        units={units}
        color="#ff9b7b"
        value={value}
      />
    </VitalPlate>
  );
};
